'use client';

import type { ReactElement } from 'react';
import { Button } from '@tranquility-ai/theme-components/button';
import { TpTooltip } from '@tranquility-ai/theme-components/tooltip';

/**
 * Tooltipped inverse icon button for a media viewer header.
 * Candidate for promotion to theme-components. The mailbox shell and the
 * UFDR preview share it so expand, new-tab, and close stay the same.
 */
export function MediaShellHeaderButton({
  label,
  onClick,
  children,
}: {
  label: string;
  onClick: () => void;
  children: ReactElement;
}) {
  return (
    <TpTooltip content={label} placement="bottom" sideOffset={4} variant="inverted">
      <Button
        type="button"
        iconOnly
        size="sm"
        style="text"
        color="light"
        background="inverse"
        aria-label={label}
        onClick={onClick}
      >
        {children}
      </Button>
    </TpTooltip>
  );
}
